import * as React from "react"
import Svg, { SvgProps, Rect } from "react-native-svg"
const DotIcon = (props: SvgProps) => (
    <Svg
        width={2}
        height={2}
        fill="none"
        {...props}
    >
        <Rect width={2} height={2} fill="#000" rx={1} />
    </Svg>
)
export default DotIcon
